<template>
    <div class="animated fadeIn h-100 admin-container">
        <div class="page-content">
            <SectionTitle :title="'Thống kê mực nước theo các trận lũ năm 2008'" />
            <table class="table table-striped table-hover">
                <thead>
                    <tr>
                        <th v-for="item in rainfallFrequencyHeader">{{ item }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in rainfallFrequencyBody">
                        <td v-for="key in item">
                            <label>{{ key }}</label>
                            <p>{{ item.key }}</p>
                        </td>
                    </tr>
                </tbody>
            </table>

            <SectionTitle :title="'Thống kê mực nước theo các trận lũ năm 2020'" class="mt-5" />
            <table class="table table-striped table-hover">
                <thead>
                    <tr>
                        <th v-for="item in rainFlowHeader">{{ item }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in rainFlowBody">
                        <td v-for="key in item">
                            <label>{{ key }}</label>
                            <p>{{ item.key }}</p>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import SectionTitle from '@/components/SectionTitle';
// For Excel Export
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
const EXCEL_TYPE =
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
export default {
    components: {
        SectionTitle
    },
    created() {
        this.initRainFlowData();
        this.initRainFallData();
    },
    data() {
        return {
            rainfallFrequencyBody: null,
            rainfallFrequencyHeader: null,
            rainFlowHeader: null,
            rainFlowBody: null
        };
    },
    methods: {
        async initRainFlowData() {
            let rainFrequency = await axios.get(
                'https://api.canhbaolu.bache.vn/api/geojson/2021_01_08_17_00_00_xlsx.geojson',
                {
                    responseType: 'blob'
                }
            );
            var reader = new FileReader();
            reader.onload = (e) => {
                var results,
                    data = e.target.result,
                    workbook = XLSX.read(data, { type: 'binary' }),
                    firstSheetName = workbook.SheetNames[0],
                    worksheet = workbook.Sheets[firstSheetName];
                this.rainfallFrequencyHeader = this.getHeaderRow(worksheet);
                results = XLSX.utils.sheet_to_row_object_array(worksheet);
                this.rainfallFrequencyBody = results;
            };
            reader.readAsBinaryString(rainFrequency.data);
        },
        async initRainFallData() {
            let rainFrequency = await axios.get(
                'https://api.canhbaolu.bache.vn/api/geojson/2021_01_08_17_00_00_xlsx.geojson',
                {
                    responseType: 'blob'
                }
            );
            var reader = new FileReader();
            reader.onload = (e) => {
                var results,
                    data = e.target.result,
                    workbook = XLSX.read(data, { type: 'binary' }),
                    firstSheetName = workbook.SheetNames[1],
                    worksheet = workbook.Sheets[firstSheetName];
                this.rainFlowHeader = this.getHeaderRow(worksheet);
                results = XLSX.utils.sheet_to_row_object_array(worksheet);
                this.rainFlowBody = results;
            };
            reader.readAsBinaryString(rainFrequency.data);
        },
        getHeaderRow(sheet) {
            var headers = [],
                range = XLSX.utils.decode_range(sheet['!ref']);
            var C,
                R = range.s.r; /* start in the first row */
            for (C = range.s.c; C <= range.e.c; ++C) {
                /* walk every column in the range */
                var cell =
                    sheet[
                        XLSX.utils.encode_cell({ c: C, r: R })
                    ]; /* find the cell in the first row */
                var hdr = 'UNKNOWN ' + C; // <-- replace with your desired default
                if (cell && cell.t) hdr = XLSX.utils.format_cell(cell);
                headers.push(hdr);
            }
            return headers;
        }
    }
};
</script>
